import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import MainLayout from "../../../../components/layout/MainLayout";
import Breadcrumbs from "../../../../components/common/Breadcrumbs";
import PsychForm from "./PsychForm";
import { useDispatch, useSelector } from "react-redux";
import { createPsychiatricForm } from "../../../../store/slices/psychiatricFormSlice";
import { fetchNurses } from "../../../../store/slices/nursingRecordsSlice"; // ✅ Import fetchNurses
import { fetchPatient } from "../../../../store/slices/patientsSlice";

const AddPsych = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};

    const { nurses } = useSelector((state) => state.nursingRecords);
    const { isLoading } = useSelector((state) => state.psychiatricForm);

    useEffect(() => {
        dispatch(fetchNurses()); // ✅ Load nurses for dropdown
        if (patientId) {
            dispatch(fetchPatient(patientId))
                .unwrap()
                .then((patient) => {
                    if (patient) {
                        setFormData((prev) => ({
                            ...prev,
                            name: `${patient.first_name || ""} ${patient.last_name || ""}`.trim(),
                            mrNo: patient.mr_no || "",
                        }));
                    }
                })
                .catch((err) => console.error("Failed to fetch patient:", err));
        }
    }, [dispatch, patientId]);

    const [formData, setFormData] = useState({
        patient_id: state?.patientId || null,
        case_id: state?.caseId || null,
        name: "",
        mrNo: "",
        roomNo: "",
        consultant: "",
        documentName: "Psychiatrist’s Order",
        effectiveDate: "",
        approvedBy: "",
        approvedDate: "",
        nextRevisionBy: "",
        nextRevisionDate: "",
    });

    const [rows, setRows] = useState([
        { id: Date.now(), date_time: "", order: "", nurse: "", nurse_id: null    }
    ]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Convert camelCase → snake_case
        const snakeForm = {
            patient_id: formData.patient_id,
            case_id: formData.case_id,
            name: formData.name,
            mr_no: formData.mrNo,            // <-- map camelCase to snake_case
            room_no: formData.roomNo,
            consultant: formData.consultant,
            document_name: formData.document_name,

            effective_date: formData.effectiveDate,
            approved_by: formData.approvedBy,
            approved_date: formData.approvedDate,
            next_revision_by: formData.nextRevisionBy,
            next_revision_date: formData.nextRevisionDate,
        };

        const payload = {
            ...snakeForm,
            orders: rows.map(r => ({
                date_time: r.date_time,
                order: r.order,
                nurse: r.nurse,
                nurse_id: r.nurse_id,
            }))
        };

        try {
            const res = await dispatch(createPsychiatricForm(payload)).unwrap();

            Swal.fire({
                title: "Saved!",
                text: "Psychiatric Form has been submitted.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
            });

            navigate(`/phase03/psychiatrist-order/edit/${res.id || res.data?.id || (res && res[0]?.id)}`, { state: { patientId: patientId || (res && res.patient_id), caseId: caseId || (res && res.case_id) } });

        } catch (error) {
            Swal.fire("Error", "Something went wrong while saving.", "error");
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <PsychForm
                                formData={formData}
                                handleChange={handleChange}
                                rows={rows}
                                setRows={setRows}
                                nurses={nurses}
                            />
                            <div className="col-12 d-flex justify-content-end mt-3">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary px-4">
                                        <i className="ri-save-2-line me-1"></i>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddPsych;
